var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep5Cbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step_3_CBS_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBS_down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.000000, 0.000000)",
    stroke: "#000100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sofa"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    x: 16.4977064,
    y: 13.1172427,
    width: 60.2522936,
    height: 59.6649647,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    x: 17.6279817,
    y: 14.2484289,
    width: 57.9917431,
    height: 57.4025923,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    x: 77.25,
    y: 13.1172427,
    width: 60.2522936,
    height: 59.6649647,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#D8D8D8",
    x: 78.3802752,
    y: 14.2484289,
    width: 57.9917431,
    height: 57.4025923,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#C4C3C2",
    x: 77.25,
    y: 13.1172427,
    width: 51.987156,
    height: 16.4677926,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#C4C3C2",
    x: 24.762844,
    y: 13.1172427,
    width: 51.987156,
    height: 16.4677926,
    rx: 1.41398272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.75,12.5516496 L153.75,72.7822074 L137.861009,72.7822074 L137.861009,12.5516496 L153.75,12.5516496 Z",
    id: "Fill-20",
    strokeWidth: 0.5,
    fill: "#EAE6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1389908,12.5516496 L16.1389908,72.7822074 L0.25,72.7822074 L0.25,12.5516496 L16.1389908,12.5516496 Z",
    id: "Fill-20",
    strokeWidth: 0.5,
    fill: "#EAE6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.717203,0.282796544 L153.717203,12.5844462 L137.893806,12.5844462 L137.893806,6.15082482 L132.383259,6.15082482 L132.383259,12.5844462 L21.6167415,12.5844462 L21.6167415,6.15082482 L16.1061943,6.15082482 L16.1061943,12.5844462 L0.282796544,12.5844462 L0.282796544,0.282796544 L153.717203,0.282796544 Z",
    id: "Combined-Shape",
    strokeWidth: 0.565593087,
    fill: "#D6D1AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bed",
    transform: "translate(18.013761, 6.928515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54289153,0.282796544 L2.54289153,6.78711705 L5.3685796,6.78711705 L5.3685796,23.1893166 L112.603897,23.1893166 L112.603897,6.78711705 L115.429586,6.78711705 L115.429586,0.282796544 L117.689681,0.282796544 L117.689681,172.788688 L0.282796544,172.788688 L0.282796544,0.282796544 L2.54289153,0.282796544 Z",
    id: "Combined-Shape",
    strokeWidth: 0.565593087,
    fill: "#D6D1AB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#C1BC9F",
    x: 1.59220183,
    y: 24.4998036,
    width: 114.788073,
    height: 146.978397
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.602752, 26.158680)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.30393,52.6708562 C108.30393,52.6708562 109.341201,80.6653675 109.28096,85.5119183 C109.218837,90.3567608 108.578779,104.892997 108.736911,108.029503 C108.895043,111.166008 108.324638,116.933353 108.620194,120.392734 C108.915751,123.850407 109.382617,130.331836 108.896925,133.646009 C108.414999,136.961891 110.114919,141.137065 105.314481,142.737776 C100.512161,144.338488 99.5276004,142.326067 96.3197785,143.260527 C93.1119566,144.194988 87.5848644,143.199027 81.2821721,143.204152 C74.9794798,143.207569 69.7084109,143.732028 67.0427561,143.53557 C64.3752188,143.339111 59.7009102,143.004277 54.0420413,143.117027 C48.3850549,143.229777 41.8206917,142.404651 37.0786122,142.84711 C32.3365328,143.286153 25.8926511,143.568028 23.0688642,143.523611 C20.2469598,143.479195 14.4280763,143.602195 12.8957013,143.445028 C11.3633263,143.287861 8.66002099,143.743987 6.69090027,142.78561 C4.7255446,141.827233 3.43601525,140.966231 2.95973653,138.371268 C2.48157529,135.776305 2.79407437,132.076048 2.54746365,127.149205 C2.30273545,122.224071 1.28993722,116.323477 1.61937902,112.997345 C1.94882083,109.669506 2.49851801,106.674792 2.29708788,102.636284 C2.09754027,98.5977764 2.14460339,90.5959279 2.18978398,87.3517968 C2.23308204,84.1076657 2.18790145,80.8908679 2.26885001,78.2463629 C2.34979857,75.6018579 2.11448299,53.3114825 2.11448299,53.3114825",
    id: "Fill-13",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.965279,42.9455277 L108.965279,32.056344 C108.965279,32.056344 108.510224,23.5894799 108.510224,21.5705916 C108.510224,19.5534349 108.839087,9.69100991 109.108679,7.90586944 C109.380183,6.12072897 109.070439,1.71241894 108.756871,1.14103547 C108.445216,0.571383468 106.770305,0.114276694 104.869778,0.0571383468 C102.971163,0.00173146505 4.85120441,0 4.85120441,0 C4.85120441,0 2.79771761,0.697780417 2.3005979,1.93924086 C1.8034782,3.18243277 2.02527007,11.7549163 1.87995815,13.6300929 C1.73273424,15.5052696 1.46505439,20.9195608 1.58359832,23.1964373 C1.69831826,25.4715824 3.21453337,30.6261539 2.28912591,33.9557612 C1.36371845,37.2853685 2.28912591,43.3385703 2.28912591,43.3385703",
    id: "Fill-17",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2731854,7.36306888 C98.2731854,7.36306888 99.4470533,5.4478293 96.5360062,5.98274643 C93.621325,6.51766356 84.4211808,5.3347711 80.843246,5.98274643 C77.2634941,6.62903432 71.0707049,6.3117964 67.2565429,6.19536333 C63.4405636,6.07724283 60.5040768,5.90006208 58.676041,5.76337978 C56.8498224,5.62501005 55.3161622,5.29427264 55.7359199,7.34956939 C56.1556776,9.4031787 57.7583889,11.9596439 57.6657151,14.9565298 C57.5730413,17.9534157 57.1223923,21.6235884 57.2314203,22.9043522 C57.3404483,24.1851159 57.0805983,26.5002778 56.6063266,29.0466183 C56.1356891,31.5912714 56.0829923,32.0840027 55.8613021,32.9817185 C55.6396118,33.8794343 55.7213828,34.9593932 59.099433,34.4109766 C62.4811174,33.8608725 66.9930586,33.1858982 69.0700416,33.6870666 C71.1470245,34.1882351 75.9933181,33.8153118 78.1357179,33.8018123 C80.2781177,33.7916877 86.4963466,34.4059143 88.0063841,34.4346007 C89.5164216,34.4615997 95.3148929,34.7164025 96.4524181,34.7737753 C97.5899434,34.8311481 99.4343333,35.4166883 98.3658591,32.3320557 C97.2955678,29.2457357 97.6444574,26.0345455 97.6172004,23.8729403 C97.5863091,21.7096477 97.2810308,17.2835037 97.6499088,14.2714309 C98.0187867,11.2610455 98.2731854,7.36306888 98.2731854,7.36306888",
    id: "Fill-21",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.908132,7.36307147 C53.908132,7.36307147 55.0836289,5.44782898 52.171231,5.98274693 C49.2588331,6.51766487 40.0601616,5.33477061 36.4809827,5.98274693 C32.9018038,6.6290358 26.7118227,6.3117974 22.8982712,6.19536416 C19.0829028,6.07724347 16.146886,5.90006245 14.3191428,5.76337995 C12.4913997,5.62501 10.9598018,5.29427209 11.3794923,7.34957197 C11.7991829,9.4031844 11.4012944,12.7881857 11.3104523,15.7867636 C11.2159765,18.783654 11.1978081,22.8672548 11.3068186,24.1497079 C11.4121955,25.4304736 12.7221386,26.5003095 12.2497597,29.0466539 C11.7791976,31.5913109 11.7246923,32.0823554 11.5030376,32.9817601 C11.2831997,33.8777898 11.3631407,34.9594378 14.742467,34.4093329 C18.1236102,33.8609154 22.6330122,33.1859401 24.7114796,33.6871093 C26.7881301,34.1882785 31.6318311,33.8153546 33.773888,33.8018551 C35.9159448,33.7917305 42.1349953,34.405958 43.644791,34.4346445 C45.1545868,34.4616435 50.9521299,34.7164467 52.0894731,34.7738196 C53.2268162,34.8311925 55.070911,35.4167336 54.0026078,32.3304089 C52.9324878,29.2457716 53.2813215,26.0345765 53.252252,23.872968 C53.2231826,21.7096721 52.9179531,17.2835214 53.286772,14.271444 C53.655591,11.2593666 53.908132,7.36307147 53.908132,7.36307147",
    id: "Fill-25",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.483382,59.4163387 C108.483382,59.4163387 110.285557,60.8494032 110.829788,58.7831633 C111.375901,56.7152395 111.470059,51.2759936 111.53032,48.4317563 C111.592463,45.589203 111.42298,43.4034008 111.428629,39.4763663 C111.436162,35.5493318 111.146157,31.6088255 111.174404,30.5765475 C111.200768,29.5425856 111.198885,28.0320582 109.195213,27.6447435 C107.189658,27.2557448 105.227415,27.1917536 103.253874,27.4628739 C101.280332,27.7339942 98.3595658,27.313 95.8907557,27.3702552 C93.4200624,27.4258264 89.1227133,27.5268651 87.5634648,27.6110639 C86.0023331,27.6952628 84.5466579,27.5201292 81.2756257,27.1328144 C78.0008272,26.7454997 76.3926168,27.240589 73.2364567,26.7926511 C70.0802967,26.3447132 63.6229741,25.8799355 59.6288122,26.4625916 C55.6346502,27.0452476 51.0115161,28.3688536 42.9685808,27.6262197 C34.9256456,26.8835858 29.9804927,28.4783121 26.2104257,26.9627328 C22.4365923,25.4471534 19.2295872,26.1561077 15.4614034,26.3716568 C11.6913363,26.5888898 10.359949,26.7387638 8.07757075,27.0637714 C5.79707565,27.387095 1.29446311,27.2439569 1.29446311,27.2439569 C1.29446311,27.2439569 -0.23842129,28.1549885 0.136325634,29.4263912 C0.511072558,30.6994779 0.239898905,39.3568039 0.130676183,44.2588611 C0.0214534615,49.1592344 -0.0237421474,57.8754997 0.0233366119,58.1163084 C0.0741816719,58.3554331 -0.765703394,60.6170143 4.32068576,59.75987 C9.41084121,58.9027257 13.3560412,57.9815902 18.7682154,58.1920874 C23.4195968,58.3739569 31.5058445,60.273483 34.7561621,59.4146547 C38.0064796,58.5558264 48.6895916,59.9535274 53.6799401,59.1182747 C58.0300175,58.3891127 70.5266033,58.6097137 74.2721894,58.4581557 C78.0177755,58.3082818 80.9611396,58.7680075 85.6483008,58.1937713 C88.167956,57.8856035 95.0979494,58.7898992 98.1881991,59.1132228 C101.282215,59.4348624 108.483382,59.4163387 108.483382,59.4163387",
    id: "Fill-29",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-9.147186, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-315.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-1)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(144.852814, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-45.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-1)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 1,
    x2: 240,
    y2: 1,
    id: "Line",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(195.852814, 100.852814) rotate(-90.000000) translate(-195.852814, -100.852814) translate(95.852814, 40.852814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,0 L112,107 L88,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-2)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(88.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5Cbs);
export default __webpack_public_path__ + "static/media/step_5_CBS.bded174e1d28f76d59c3e82f970a4217.svg";
export { ForwardRef as ReactComponent };